import React from 'react';
import {FrameContainer} from '../styledComponents/layout'

const Privacy = () => (
  <FrameContainer>
    <section>
      <h1>プライバシーポリシー</h1>
      <p> 株式会社abasaku(以下「当社」といいます)が、提供するインターネットサービス 「Flick!On!TV」（以下「本サービス」といいます）においてお客様（以下「ユーザー」 といいます）に関する情報を以下の通りに取り扱います。</p>
      <h2>第1条　総則</h2>
      <p>1.当社は、ユーザー情報保護の実現の為、個人情報保護法、各省庁ガイドラインその他関達する法令等を遵守いたします。</p>
      <p>2.Flick!On!TVプライバシーポリシー（以下「本ポリシー」といいます）は、本サービス（本サービスに付随して当社が提供するサービスを含みます）の利用に関し、適用されます。 また、当社運宮のウェブサイト上に掲載するプライバシーポリシーその他の個人情報保護方針又はFlick!On!TVに関する利用規約等において、ユーザー情報の取扱いを規定する場合、当該規定も適用されるものとし、当該規定等が本ポリシーと抵触する場合には、本ポリシーが優先されるものとします。</p>
      <p>3.提携パートナーにより提供される提携サービスその他当社以外の者が提供するサービスについては、本ポリシーの規定は適用されません。これらのサービスにおけるユーザー情報の取扱いについては、当該外部サービスを提供する事業者が別途定めるプライバシーポリシー等をご参照ください。</p>
      <h2>第2条　取得情報</h2>
      <p>1.当社は、本サービスにおいて、以下に定める通り、個人情報（個人情報保護法第2条第1項により定義された「個人情報」をいい、以下同様とします)を含むユーザー情報を取得します。</p>
      <p>(1)ご提供いただく情報</p>
      <p>ア　基礎情報：携帯電話番号（SMS認証）、Googleアカウント、Facebookアカウント等
        当社は、お客様がアカウントを新規登録される際に、お客様を特定、識別し得る情報（以下「個人情報」といいます）を収集します。具体的には、</p>
      <p>・お電話番号（SMS認証）で登録していただく方法に関しては、携帯電話番号を収集します。
        ・Google、Facebookアカウントをお持ちの方は、いずれかのプライバシー設定により当社からのアクセスが許容されるユーザIDを収集します。</p>
      <p>イ　その他登録情報：ニックネーム、生年月日、性別、都道府県、ご職業（任意） 、プロフィール写真（任意）その他のプロフィール情報をユーザーとしてご登録いただくことがあります。</p>
      <p>(2) 本サービスご利用時に当社が収集する情報</p>
      <p>ア　端末情報</p>
      <p>当社は、本サービスの維持及び改善又は不正行為防止のため、ユーザーが使用される端末固有の情報（端末固有のID等の個体識別情報等）を収集することがあります。</p>
      <p>イ　ログ情報及び行動履歴情報</p>
      <p>当社は、本サービスの維持及び改善又は不正行為防止を目的として、本サービス利用時に自動で生成、保存されるIPアドレス、ユーザーからのリクエスト日時、アプリ内での操作履歴情報等を収集することがあります。</p>
      <p>ウ　位置情報</p>
      <p>当社は、ユーザーの現在位置等の情報を利用したサービスを提供するため、当該サービスの提供に必要な範囲内で、ユーザーのスマートフォン端末、タブレット瑞末その他の情報端末等から送信される位置情報を収集することがあります。なお、情報端末上の設定の変更により位置情報の送信を停止することができますが、本サービスの機能の一部を利用出来なくなる場合があります。</p>
      <p>2.当社は、ユーザー情報取得にあたり、虚偽その他不正の手段によらず、適正な方法により取得します。また、当社はユーザーが本サービスを利用による取得以外の方法でユーザー情報を取得する場合には、その利用目的を事前に通知又は公表します。</p>
      <h2>第3条　利用目的</h2>
      <p>1.当社は、本サービスの利用を通じて取得したユーザー情報を、下記の目的の範囲内で適正に取り扱います。ユーザーご本人の同意なく利用目的の範囲を超えて利用することはありません。</p>
      <p>（１）本サービスの提供・維持・改善</p>
      <p>・本サービスにおけるご本人確認及び不正利用防止</p>
      <p>・他ユーザへの通知、通信その他のコミュニケーション機能を含む本サービスの円滑な提供、維持及び改善</p>
      <p>・本サービスに関するユーザーへのアンケート等の実施</p>
      <p>（２）ユーザーへの通知・対応</p>
      <p>・本サービスに関するご案内、お問い合わせ等への対応</p>
      <p>・本サービスに関連する新たなサービスの通知又は提供</p>
      <p>・本サービスに関する利用規約又は本ポリシーの変更</p>
      <p>・本サービスの停止・中止・契約解除</p>
      <p>・その他本サービスに関する重要なお知らせ等の通知</p>
      <p>（３）第三者提供</p>
      <p>下記に記載の情報提供を受けた第三者は、当該情報を以下の目的の為に利用します。
        ・提携サービスの提供
        ・ユーザーニーズや興味・関心にマッチした広告等の表示
        ・広告効果分析
        ・市場調査及び分析</p>
      <p>2.当社は、前項の利用目的を、変更前の利用目的と相当の関連性を有すると合理的に認められる範囲内にて変更することがあり、変更した場合には、当社が別途定める方法により、ユーザーに通知又は公表します。</p>
      <h2>第4条　ユーザー情報の第三者提供</h2>
      <p>1.当社は、ユーザー情報のうち、個人情報については、以下の場合を除き、第三者に提供することはありません。</p>
      <p>(1)ユーザーの同意を得た場合</p>
      <p>(2)法令に基づく場合</p>
      <p>(3)本サービス利用上、ユーザーが他人の利益を害し若しくは公序良俗に反する行為その他本サービスの利用規約に達反する行為を行い又はこれを行おうとするときに、当該行為に対して必要な処置を取る場合</p>
      <p>(4)人の生命、身体又は財産の保護のために必要がある場合であり、本人の同意を得ることが困難であるとき</p>
      <p>(5)公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</p>
      <p>(6)国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</p>
      <p>(7)合併、会社分割、事業譲渡その他の事由によりユーザーの個人情報を含む事業の継承がなされる場合</p>
      <p>2.当社は、本サービスと提携するサービス（以下「提携サービス」といいます）を提供する事業者（以下「提携パートナー」といいます）に対し、ユーザーに提携サービスを提供するため、ユーザーの同意を得た上で個人情報を含むユーザー情報を提供することができるものとします。</p>
      <h2>第5条 お子様の個人情報について</h2>
      <p>満15歳未満のお客様が本サービスを利用し、個人情報を入力される場合には、保護者の方の同意が必要となります。</p>
      <h2>第6条　個人情報の取扱いの委託</h2>
      <p>当社は、ユーザーから取得した個人情報の全部又は一部の取扱いを第三者に委託（個人情報を含む情報の管理を事業者に委託する場合などをいいます）することがあります。この場合、当社は、当該委託先との間で本ポリシーに準じる内容の秘密保持契約等をあらかじめ締結するとともに、当該委託先において情報の適切な安全管理が図られるよう、必要かつ適切な監督を行います。</p>
      <h2>第7条　共同利用</h2>
      <p>当社は、提携パートナーとの間で、提携サービスの提供に必要な範囲において、ユーザーの個人情報を共同で利用することがあります。この場合当社はあらかじめ、提携パートナーの名称、共同利用目的、共同利用する情報の種類を公表するものとします。</p>
      <h2>第8条　安全管理体制</h2>
      <p>1.当社は、ユーザー情報の漏洩、滅失又は毀損の防止その他のユーザー情報の保護のため、 個人情報ファイルヘのアクセス制限の実施、アクセスログの記録、また外部からの不正アクセス防止のためのセキュリティソフトの導入等、ユーザー情報の安全管理のために必要かつ適切な措置を講じています。</p>
      <p>2.当社は、代表取締役をユーザー情報管理責任者とし、ユーザー情報の適正な管理及び継続的な改善を実施します。</p>
      <h2>第9条　ユーザーの情報開示・訂正等の権利</h2>
      <p>1.ユーザーは当社に提供した個人情報について、以下に定める手続きに従い、開示を請求することができます。</p>
      <p>(1)当社ウェブサイト上の所定のフォームに入力し送信する方法、又は申請書に本人確認（代理人による申請の場合、適正な代理人であることの確認）のために必要な書類を同封のうえ、郵送する方法によりご請求ください。書面による申請の場合は、1回の申請につき手数料1,000円を申し受けます。</p>
      <p>(2)前号に基づく申出につき本人確認がなされたときは、当社は、合理的な範囲で個人情報の開示を実施します。ただし、個人情報保譲法その他の法令により当社が開示義務を負わない場合又は正当な理由なく同内容の請求が何度も繰り返される場合は、この限りではありません。</p>
      <p>2.当社の保有するユーザーに関する個人情報の内容が事実と異なる場合、ユーザーは、以下に定める手続に従い、訂正、追加、削除を請求することができます。</p>
      <p> (1)当社ウェブサイト上の所定のフォームに入力し送信する方法、又は申請書に本人確認（代理人による申請の場合、適正な代理人であることの確認）のために必要な書類を同封のうえ、郵送によりご請求ください。</p>
      <p> (2)前号に基づく申出につき本人確認がなされたときは、当社は、合理的な範囲で遅滞なく調査を行い、その結果に基づき個人情報の訂正、追加、削除をします。ただし、個人情報保護法その他の法令により当社がこれらの義務を負わない場台、正当な理由なく同内容の請求が何度も繰り返される場合、又は過度な技術的作業を要する場合はこの限りではありません。</p>
      <h2>第10条　本ポリシーの変更</h2>
      <p>1.当社は、ユーザー情報の取扱いに関する運用状況を適宜見直し、継統的な改善に努めるものとし、必要に応じて、随時本ポリシーを変更することがあります。</p>
      <p>2.変更後の本ポリシーについては、本サービス上又は当社の運営するウェブサイトでの掲示その他の分かりやすい方法により告知します。ただし、法令上ユーザーの同意が必要となるような内容の変更を行うときは、別途当社が定める方法により、ユーザーの同意を取得します。</p>
      <h2>第11条　取得情報の破棄</h2>
      <p>取得したユーザーの個人情報は、当社による通常の事業運営に照らして、合理的に不要と判断される時点で破棄します。</p>
      <h2>第12条　お問い合わせ</h2>
      <p>当社のユーザー情報の取扱いに関するご意見、ご質問、苦情のお申し出、その他ユーザー情報の取扱いに関するお問い合わせは、下記窓口までご連絡ください。</p>
      <p>株式会社 abasaku</p>
      <p>〒107-0062 東京都港区南青山1-15-18 リーラ乃木坂 701</p>
      <p>support@flickontv.jp</p>
      <p>2016年10月21日制定</p>
      <p>© 2018 abasaku Inc.</p>
    </section>
  </FrameContainer>
);
export default Privacy;



// WEBPACK FOOTER //
// ./src/pages/privacy.js